'use client';
import { jsx } from '@emotion/react/jsx-runtime';
import { composeHandlers } from '@s7/react-utils';
import { isString } from '@s7/utils';
import { useAnalytics } from '../../analytics.js';
import { FooterSocial } from '../../../../Footer/components/Social/FooterSocial.js';
import { compileTemplate } from '../../../../common/compileTemplate/compileTemplate.js';
import { composeOptions } from '../utils/composeOptions.js';

function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
const SocialContainer = (props)=>{
    const { copyright, handlers } = props, others = _object_without_properties_loose(props, [
        "copyright",
        "handlers"
    ]);
    const completeCopyright = isString(copyright) ? compileTemplate(copyright, {
        year: new Date().getFullYear()
    }) : undefined;
    const { onItemClick } = handlers || {};
    const footerTopic = useAnalytics('footer');
    const dispatchEvent = (item)=>footerTopic.clickSocialMedia(item.variant);
    return /*#__PURE__*/ jsx(FooterSocial, _extends({
        copyright: completeCopyright
    }, others, {
        onItemClick: composeHandlers(onItemClick, dispatchEvent, composeOptions)
    }));
};

export { SocialContainer };
//# sourceMappingURL=SocialContainer.js.map
